import { useState } from "react";
import { toast } from "sonner";
import ApplicationForm from "@/components/ApplicationForm";
import ReturningGuest from "@/components/ReturningGuest";
import SubmissionDialog from "@/components/SubmissionDialog";
import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";
import ImageMarquee from "@/components/ImageMarquee";

export default function RsvpPage() {
  const [mode, setMode] = useState("apply");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogVariant, setDialogVariant] = useState("submitted");

  const handleSubmitted = () => {
    setDialogVariant("submitted");
    setDialogOpen(true);
  };
  const handleVipConfirmed = () => {
    setDialogVariant("vip");
    setDialogOpen(true);
  };

  return (
    <div className="min-h-screen" data-testid="rsvp-page">
      <SiteHeader />

      <section className="container-kynn pt-20 pb-8">
        <div className="grid grid-cols-12 gap-10">
          <div className="col-span-12 lg:col-span-4">
            <div className="small-caps mb-6" style={{ color: "#B9929D" }}>
              Apply here
            </div>
            <h1
              className="font-display fade-up"
              style={{
                fontSize: "clamp(48px, 6vw, 80px)",
                lineHeight: 1.02,
                color: "#F2EEE7",
                letterSpacing: "-0.02em",
              }}
            >
              Six questions.<br />
              <em style={{ color: "#DDBFCF" }}>Request an invite.</em>
            </h1>
            <p className="mt-8" style={{ color: "#F2EEE7", opacity: 0.8, lineHeight: 1.75 }}>
              We read every application looking for genuine women who&rsquo;ll actually benefit from being in the room. Returning members get first priority, but we&rsquo;re always making space for new faces.
            </p>

            <div
              className="mt-10 inline-flex overflow-hidden"
              style={{ border: "1px solid rgba(221, 191, 207,0.35)", borderRadius: "8px" }}
            >
              <button
                data-testid="mode-apply-btn"
                onClick={() => setMode("apply")}
                className="small-caps px-5 py-3 transition-colors"
                style={{
                  background: mode === "apply" ? "#E2D3E2" : "transparent",
                  color: mode === "apply" ? "#240F1C" : "#F2EEE7",
                }}
              >
                Apply
              </button>
              <button
                data-testid="mode-returning-btn"
                onClick={() => setMode("returning")}
                className="small-caps px-5 py-3 transition-colors border-l"
                style={{
                  borderColor: "rgba(221, 191, 207,0.35)",
                  background: mode === "returning" ? "#E2D3E2" : "transparent",
                  color: mode === "returning" ? "#240F1C" : "#F2EEE7",
                }}
              >
                Returning guest
              </button>
            </div>
          </div>

          <div className="col-span-12 lg:col-span-7 lg:col-start-6">
            {mode === "apply" ? (
              <ApplicationForm onSubmitted={handleSubmitted} onError={(m) => toast.error(m)} />
            ) : (
              <ReturningGuest onConfirmed={handleVipConfirmed} onError={(m) => toast.error(m)} />
            )}
          </div>
        </div>
      </section>

      <ImageMarquee />

      <SiteFooter />

      <SubmissionDialog open={dialogOpen} onOpenChange={setDialogOpen} variant={dialogVariant} />
    </div>
  );
}
